import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface FollowsState {
  followedUserIds: string[];
}

const initialState: FollowsState = {
  followedUserIds: [],
};

const followsSlice = createSlice({
  name: 'follows',
  initialState,
  reducers: {
    toggleSuggestedFollowee: (state, action: PayloadAction<string>) => ({
      ...state,
      followedUserIds: state.followedUserIds.includes(action.payload)
        ? state.followedUserIds.filter((id) => id !== action.payload)
        : [...state.followedUserIds, action.payload],
    }),
    resetFollowedUserIds: () => initialState,
  },
});

export const { toggleSuggestedFollowee, resetFollowedUserIds } = followsSlice.actions;
export const followsReducer = followsSlice.reducer;
